import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {Grid, makeStyles} from '@material-ui/core';
import BasicsInfo from './BasicsInfo';
import SubjectsInfo from './SubjectsInfo';

const useStyles = makeStyles(() => ({
  root: {},
}));

const Details = ({
  user,
  subjects,
  className,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <Grid
      className={clsx(classes.root, className)}
      container
      spacing={3}
      {...rest}
    >
      <Grid
        item
        lg={4}
        md={6}
        xl={3}
        xs={12}
      >
        <BasicsInfo user={user} />
      </Grid>
      <Grid
        item
        lg={4}
        md={6}
        xl={8}
        xs={12}
      >
        <SubjectsInfo subjects={subjects} />
      </Grid>
    </Grid>
  );
};

Details.propTypes = {
  className: PropTypes.string,
  user: PropTypes.object.isRequired,
  subjects: PropTypes.object.isRequired,
};

export default Details;
